export const REMINDER_TASK_STATUS = {
  PENDING: "Pending",
  PROCESSING: "Processing",
  COMPLETED: "Completed",
  FAILED: "Failed",
};

export const REMINDER_AUDIENCE_TYPE = {
  INTERNAL: "Internal",
  CONTACT_WHATSAPP: "ContactWhatsApp",
};

export const REMINDER_NOTIFICATION_CHANNEL = {
  IN_APP: "InApp",
  WHATSAPP: "WhatsApp",
};

export const REMINDER_WHATSAPP_SEND_MODE = {
  DIRECT_TEXT: "WhatsAppDirectText",
  TEMPLATE: "WhatsAppTemplate",
};

export const REMINDER_CHANGED_EVENT = "reminders:changed";

export function isReminderCompleted(status) {
  return String(status || "").toLowerCase() ===
    REMINDER_TASK_STATUS.COMPLETED.toLowerCase();
}

export function isReminderPending(status) {
  return String(status || "").toLowerCase() ===
    REMINDER_TASK_STATUS.PENDING.toLowerCase();
}

export function isReminderFailed(status) {
  return String(status || "").toLowerCase() ===
    REMINDER_TASK_STATUS.FAILED.toLowerCase();
}

export function isReminderProcessing(status) {
  return String(status || "").toLowerCase() ===
    REMINDER_TASK_STATUS.PROCESSING.toLowerCase();
}

export function deriveReminderAudience(reminder) {
  const explicitAudience = reminder?.audienceType || reminder?.AudienceType;
  if (explicitAudience) return explicitAudience;

  if (
    reminder?.sendWhatsappNotification ||
    reminder?.notificationChannel === REMINDER_NOTIFICATION_CHANNEL.WHATSAPP
  ) {
    return REMINDER_AUDIENCE_TYPE.CONTACT_WHATSAPP;
  }

  return REMINDER_AUDIENCE_TYPE.INTERNAL;
}

export function dispatchReminderChanged() {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(REMINDER_CHANGED_EVENT));
}

export function getReminderTypeLabel(reminderType) {
  const normalized = String(reminderType || "").trim().toLowerCase();

  if (normalized === REMINDER_WHATSAPP_SEND_MODE.DIRECT_TEXT.toLowerCase()) {
    return "WhatsApp Free Message";
  }

  if (normalized === REMINDER_WHATSAPP_SEND_MODE.TEMPLATE.toLowerCase()) {
    return "WhatsApp Approved Template";
  }

  return reminderType || "-";
}
